import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, BaseEntity } from '@m4u-angular/base/entities/BaseEntities';
import { EnumPageDisplayModes, EnumPageEntitySources } from '@m4u-angular/core/framework/sysenums.enum';

class State extends BaseState {
    HtmlBody: SafeHtml;
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-preview-dialog',
    templateUrl: './notification-preview-dialog.component.html',
    styleUrls: ['./notification-preview-dialog.component.scss']
})
export class NotificationPreviewDialogComponent extends BasePageComponent<BaseEntity, State> {

    @Input() set HTMLBody(value: string) {
        if (value) { this.State.HtmlBody = this.sanitizer.bypassSecurityTrustHtml(value); }
    }

    constructor(A: ServiceBagService,
        private sanitizer: DomSanitizer) {
        super(A, 'NotificationPreviewDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }
}
